<div class="session-expired" role="dialog" aria-modal="true" aria-labelledby="session-expired-title">
  <div class="session-expired-card">
    <ng-icon name="tablerClockExclamation" size="2.5rem" class="session-expired-icon" />
    <h2 id="session-expired-title">Your session has expired</h2>
    <p>Sign in again to continue. Anything you have entered but not yet saved is kept, and the action you were performing will resume.</p>
    @if (reauth.error(); as error) {
      <p class="session-expired-error">{{ error }}</p>
    }
    <div class="session-expired-actions">
      <onrsr-button color="primary" fillMode="solid" icon="tablerLogin" [isSaving]="reauth.busy()" (click)="reauth.signIn()"> Sign in </onrsr-button>
      <onrsr-button color="secondary" fillMode="onrsr-flat" [disabled]="reauth.busy()" (click)="auth.logout()">Sign out</onrsr-button>
    </div>
  </div>
</div>
